import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import { Outlet } from "react-router-dom";
import { Layout as DashboardLayout } from "src/layouts/dashboard";

const IndexPage = lazy(() => import("src/pages/dashboard/index"));
const VerifyKYCPage = lazy(() => import("src/pages/dashboard/verify-kyc"));
const VerifyKYBPage = lazy(() => import("src/pages/dashboard/verify-kyb"));
const CSVUploadPage = lazy(() => import("src/pages/dashboard/csv-upload"));
const AdminProfile = lazy(() => import("src/pages/admin-profile"));

// Customers
const CustomerListPage = lazy(
  () => import("src/pages/dashboard/customers/list")
);
const TransactionsListPage = lazy(
  () => import("src/pages/dashboard/transactions/list")
);
const TeamPage = lazy(() => import("src/pages/dashboard/team/teamPage"));
const BlankPage = lazy(() => import("src/pages/dashboard/blank"));
const UsersListPage = lazy(() => import("src/pages/dashboard/users/index"));
const UserProfile = lazy(() => import("src/pages/dashboard/users/UserProfile"));
const ClientProfile = lazy(
  () => import("src/pages/components/clients/client-profile")
);
const VerifyKYBForm = lazy(
  () => import("src/pages/dashboard/verify-kyb/index")
);
const ShowCase = lazy(() => import("src/pages/dashboard/showcase/index"));
const Settings = lazy(() => import("src/pages/Settings/index"));
const Wallets = lazy(() => import("src/pages/dashboard/Wallets"));
const RatesConf = lazy(() => import("src/pages/dashboard/Rates"));
const House = lazy(() => import("src/pages/House"));
const OTC = lazy(() => import("src/pages/dashboard/otc/otcTransactions"));
const OTCTrade = lazy(() => import("src/pages/dashboard/otc/otcTrade"));
const OTCWallet = lazy(() => import("src/pages/dashboard/otc/otcWallet"));
const ClientWhitelisted = lazy(() => import("src/pages/dashboard/otc/clientWhitelisted"));
const ConfigPage = lazy(() => import("src/pages/dashboard/config/index"));
const SystemStatusPage = lazy(() => import("src/pages/dashboard/system-status"));
const AdminManagePage = lazy(() => import("src/pages/dashboard/admin-manage/list"));
const PaymentGatewayPage = lazy(() => import("src/pages/dashboard/payment-gateway/list"));
const PaywizePayoutsPage = lazy(() => import("src/pages/dashboard/payment-gateway/payoutTransactions"));
const SubscribersPage = lazy(() => import("src/pages/dashboard/subscribers/index"));

export const dashboardRoutes: RouteObject[] = [
  {
    path: "dashboard",
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />,
      },
      {
        path: "verify-kyc",
        element: <VerifyKYCPage />,
      },
      {
        path: "KYB",
        element: <House />,
      },
      {
        path: "otc",
        element: <OTC />,
        children: [
          {
            index: true,
            element: <OTC />,
          },
          {
            path: ":clientId",
            element: <OTC />,
          },
         
        ],

        
      },
      {
        path: "otcTrade",
        element: <OTCTrade />,
        children: [
          {
            index: true,
            element: <OTCTrade />,
          },
          {
            path: ":clientId",
            element: <OTCTrade />,
          },
         
        ],
      },
      {
        path: "otcWallet",
        element: <OTCWallet />,
      },
      {
        path: "clientWhitelisted",
        element: <ClientWhitelisted />,
      },
      {
        path: "config",
        element: <ConfigPage />,
      },
      {
        path: "showcase",
        element: <ShowCase />,
      },
      {
        path: "Rates",
        element: <RatesConf />,
      },
      {
        path: "wallets",
        element: <Wallets />,
      },
      {
        path: "csv-upload",
        element: <CSVUploadPage />,
      },
      {
        path: "production",
        element: <House />,
      },
      {
        path: "deploy",
        element: <House />,
      },
   
      
      
      {
        path: "settings",
        element: <Settings />,
      },
      {
        path: "users",
        children: [
          {
            index: true,
            element: <UsersListPage />,
          },
          {
            path: ":clientId",
            element: <UsersListPage />,
          },
          {
            path: ":clientId/profile/:userId",
            element: <UserProfile />,
          },
        ],
      },
      {
        path: "customers",
        children: [
          {
            index: true,
            element: <CustomerListPage />,
          },
          {
            path: ":clientId",
            element: <ClientProfile />,
          },
        ],
      },
      {
        path: "transactions",
        children: [
          {
            index: true,
            element: <TransactionsListPage />,
          },
        ],
      },
      {
        path: "team",
        children: [
          {
            index: true,
            element: <TeamPage />,
          },
        ],
      },
      {
        path: "system-status",
        element: <SystemStatusPage />,
      },
      {
        path: "admin-manage",
        element: <AdminManagePage />,
      },
      {
        path: "payment-gateway",
        element: <PaymentGatewayPage />,
      },
      {
        path: "new-transactions",
        element: <PaywizePayoutsPage />,
      },
      {
        path: "subscribers",
        element: <SubscribersPage />,
      },
      {
        path: "blank",
        element: <BlankPage />,
      },
      {
        path: "profile",
        element: <AdminProfile />,
      },
    ],
  },
];
